import React from 'react';
import { getAuthToken } from './authToken';

// ── Nakładka "Podłącz konto Allegro" (OPENkontakt) ────────────────────────────
// Okno na tle strony (ten sam wzorzec co MMEmailSetupBanner / kreator) pokazywane
// w modułach zależnych od Allegro, gdy firma NIE ma podpiętego konta Allegro.
// Tekst dostosowany per moduł (prop message). Przycisk podpina Allegro tym samym
// mechanizmem OAuth co kreator.
//
// Po powrocie z OAuth (znacznik mm_return_module == returnModule) pokazuje EKRAN
// GRATULACJI "✓ Konto Allegro podłączone" — wzorzec z kreatora (justConnectedAllegro).
//
// Props:
//   message      - zdanie zachęty dopasowane do modułu (np. "aby zarządzać ofertami...")
//   onClose      - zamknięcie nakładki (× lub "Przejdź do modułu")
//   returnModule - nazwa modułu (np. "ratings") — zapisywana przed OAuth, po powrocie
//                  wyzwala ekran gratulacji

const COLOR = '#15803d';

// Otwiera asystenta AI (flaga nasłuchiwana w AIAssistant.tsx). NIE ustawia kontekstu —
// asystent ma już kontekst biezacego modułu (ustawiony przez App).
function openAssistant() {
  try {
    localStorage.setItem('assistant_open_request', String(Date.now()));
  } catch (e) { /* ignoruj */ }
}

export default function MMAllegroSetupBanner({ message, onClose, returnModule, showCongrats }: { message: string; onClose: () => void; returnModule?: string; showCongrats?: boolean }) {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  // Czy właśnie wróciliśmy z OAuth dla TEGO modułu? (wzorzec kreatora: returnedFromAllegro)
  const justConnected = !!showCongrats; // decyzje o gratulacjach podejmuje modul (rodzic)

  // Podpięcie Allegro — ten sam mechanizm co kreator/Settings: przekierowanie na OAuth.
  const connectAllegro = () => {
    const token = getAuthToken();
    // A2: zapamietaj z ktorego modulu klient klikal — po powrocie pokażemy gratulacje tutaj
    try { if (returnModule) localStorage.setItem('mm_return_module', returnModule); } catch (e) {}
    (window as any).__allowNavigation = true; // pomin ostrzezenie beforeunload z App.tsx
    window.location.href = '/api/allegro/login?token=' + token;
  };

  const overlay: React.CSSProperties = {
    position: 'fixed', inset: 0, zIndex: 10001,
    background: 'rgba(15,23,42,0.55)', backdropFilter: 'blur(2px)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: isMobile ? 12 : 24,
  };
  const card: React.CSSProperties = {
    background: '#fff', borderRadius: 16, width: '100%', maxWidth: 520,
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)', overflow: 'hidden',
    display: 'flex', flexDirection: 'column', maxHeight: '92vh',
  };
  const headerStyle: React.CSSProperties = {
    padding: isMobile ? '14px 18px' : '18px 24px', borderBottom: '1px solid #eef2f7',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10,
  };
  const bodyStyle: React.CSSProperties = {
    padding: isMobile ? '24px 18px' : '32px', overflowY: 'auto', flex: 1, textAlign: 'center',
  };
  const primaryBtn: React.CSSProperties = {
    padding: '13px 28px', borderRadius: 10, border: 'none', background: COLOR,
    color: '#fff', fontSize: 16, fontWeight: 600, cursor: 'pointer',
  };
  const h1: React.CSSProperties = { fontSize: isMobile ? 20 : 24, fontWeight: 700, color: '#111827', margin: '0 0 8px' };
  const sub: React.CSSProperties = { fontSize: 14, color: '#6b7280', margin: '0 0 22px', lineHeight: 1.5 };

  return (
    <div style={overlay}>
      <div style={card}>
        <div style={headerStyle}>
          <span style={{ fontSize: 13, fontWeight: 600, color: '#6b7280' }}>Konto Allegro</span>
          <button onClick={onClose} style={{ border: 'none', background: 'transparent', color: '#9ca3af', fontSize: 20, cursor: 'pointer', lineHeight: 1, padding: 0 }}>×</button>
        </div>
        <div style={bodyStyle}>
          {justConnected ? (
            // ─── EKRAN GRATULACJI (po powrocie z OAuth) ───
            <>
              <div style={{ fontSize: 48, marginBottom: 12 }}>🎉</div>
              <h1 style={h1}>Konto Allegro podłączone!</h1>
              <p style={sub}>
                Świetnie — OPENkontakt zaczął już pobierać dane z Twojego konta Allegro.
                Za chwilę zobaczysz tutaj swoje dane.
              </p>
              <button onClick={onClose} style={primaryBtn}>Przejdź dalej →</button>
            </>
          ) : (
            // ─── EKRAN ZACHĘTY (brak konta) ───
            <>
              <div style={{ fontSize: 44, marginBottom: 12 }}>🛒</div>
              <h1 style={h1}>Podłącz konto Allegro</h1>
              <p style={sub}>{message}</p>
              <button onClick={connectAllegro} style={primaryBtn}>Podłącz Allegro</button>
              <p style={{ fontSize: 12, color: '#9ca3af', marginTop: 14 }}>
                Przeniesiemy Cię na Allegro, aby autoryzować połączenie. Wrócisz tu automatycznie.
              </p>
              <div style={{ marginTop: 14 }}>
                <button type="button" onClick={() => openAssistant()}
                  style={{ border: 'none', background: 'transparent', color: COLOR, fontSize: 13, cursor: 'pointer', fontWeight: 500, textDecoration: 'underline' }}>
                  🤖 Masz pytania? Zapytaj asystenta AI
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
